export default "__VITE_ASSET__3539W$JA__"